const VERSION = {
  frontend: '7.6.0',
};

export default VERSION;
